module.exports = __webpack_public_path__ + "img/difficult-conversation-poster.1153c085.jpg";